import { createNoParamsFetcher } from '../contexts/Fetcher';
import { apiProductPackage } from '../resources/api/apiProductPackage';

const { useGetPackages } = apiProductPackage;

export const ProductPackagesFetcher = createNoParamsFetcher(() => useGetPackages().execute);
